<!--
 * @Author: mqlpcthree mql_pcthree@163.com
 * @Date: 2024-03-26 10:28:17
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @LastEditTime: 2024-05-25 16:38:39
 * @FilePath: \mei_qi_zeroweb_endlyq\src\views\paperless\components\quantityInputModule\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="inputNumber">
    <span @click="numberMinus" class="iconfont icon-jian"></span> <span><input type="number" onfocus="this.select()" v-bind:value="numberOfSubCards" @keyup="update" @blur="loseFocus"/></span> <span @click="numberOfAdditions" class="iconfont icon-jia"></span>
  </div>
</template>

<script>
export default {
  name: "inputNumber",
  data() {
    return {};
  },
  props: {
    numberOfSubCards: {
      type: Number,
      default: 0,
    },
    maxNumber: {
      type: String,
      default: "infinite",
    },
    minNumber: {
      type: String,
      default: "infinite",
    },
  },
  methods: {
    numberOfAdditions() {
      let total = JSON.stringify(this.numberOfSubCards + 1) === "NaN" ? 0 : this.numberOfSubCards + 1;
      if (this.maxNumber === "infinite") return this.$emit("updateVisible", total);
      let calculate = total >= Number(this.maxNumber) ? Number(this.maxNumber) : total;
      return this.$emit("updateVisible", calculate);
    },
    numberMinus() {
      let total = JSON.stringify(this.numberOfSubCards - 1) === "NaN" ? 0 : this.numberOfSubCards - 1;
      if (this.minNumber === "infinite") return this.$emit("updateVisible", total);
      let calculate = total <= Number(this.minNumber) ? Number(this.minNumber) : total;
      return this.$emit("updateVisible", calculate);
    },
    update($event) {
      let calculate = Number($event.target.value);
      console.log(this.maxNumber === "infinite" && this.minNumber === "infinite");
      console.log(this.minNumber === "infinite");
      console.log(this.maxNumber === "infinite");
      console.log(calculate >= Number(this.maxNumber) && calculate <= Number(this.minNumber));
      if (this.maxNumber === "infinite" && this.minNumber === "infinite") return this.$emit("updateVisible", calculate);
      else if (this.maxNumber === "infinite") return this.$emit("updateVisible", calculate <= Number(this.minNumber) ? Number(this.minNumber) : calculate);
      else if (this.minNumber === "infinite") return this.$emit("updateVisible", calculate >= Number(this.maxNumber) ? Number(this.maxNumber) : calculate);
      return this.$emit("updateVisible", calculate < Number(this.maxNumber) && calculate > Number(this.minNumber) ? calculate : 0);
    },
    loseFocus($event) {
      if ($event.target.value === "") {
        if (this.minNumber === "infinite") this.$emit("updateVisible", 0);
        else this.$emit("updateVisible", Number(this.minNumber));
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.inputNumber {
  margin: 10px 0;
  display: flex;
  align-items: center;
  > span {
    margin: 0 5px;
    font-size: 28px;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    > input {
      padding: 0 5px;
      box-sizing: border-box;
      width: 60px;
      height: 35px;
      font-size: 16px;
      text-align: center;
      background-color: #e3e3e3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/quantityInputModule/index.vue